import { useEffect } from 'react';
import { useAppLocale } from './useAppLocale';
import i18n from '../i18n';

/** Keeps i18next language in sync with the URL locale. */
export function useI18nLocaleSync() {
  const locale = useAppLocale();
  useEffect(() => {
    void i18n.changeLanguage(locale);
  }, [locale]);
}
